module.exports = __webpack_public_path__ + "img/1.1.a62e4b24.png";